import React from 'react';
import { PhoneIcon, EnvelopeIcon, MapPinIcon } from '@heroicons/react/24/outline';
import { Application } from '../../../types';

interface Props {
  application: Application;
  isEditing: boolean;
  onUpdate: (field: string, value: any) => void;
}

const ContactInfoSection: React.FC<Props> = ({ application, isEditing, onUpdate }) => {
  const addr = (application.address || {}) as any;
  const handleAddressChange = (field: string, value: string) => {
    onUpdate('address', { ...addr, [field]: value });
  };

  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
      <h3 className="text-lg font-semibold text-gray-900 mb-4 flex items-center">
        <PhoneIcon className="w-5 h-5 mr-2 text-primary-600" />
        Contact Information
      </h3>

      <div className="space-y-4">
        <div className="flex items-center space-x-2">
          <EnvelopeIcon className="w-4 h-4 text-gray-400" />
          <div className="flex-1">
            <label className="text-sm font-medium text-gray-600">Email</label>
            {isEditing ? (
              <input
                type="email"
                value={application.emailId || ''}
                onChange={(e) => onUpdate('emailId', e.target.value)}
                className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
              />
            ) : (
              <p className="text-gray-900">{application.emailId || 'N/A'}</p>
            )}
          </div>
        </div>

        <div className="flex items-center space-x-2">
          <PhoneIcon className="w-4 h-4 text-gray-400" />
          <div className="flex-1">
            <label className="text-sm font-medium text-gray-600">Mobile</label>
            {isEditing ? (
              <input
                type="tel"
                value={application.mobileNumber || ''}
                onChange={(e) => onUpdate('mobileNumber', e.target.value)}
                className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
              />
            ) : (
              <p className="text-gray-900">{application.mobileNumber || 'N/A'}</p>
            )}
          </div>
        </div>

        <div className="flex items-start space-x-2">
          <MapPinIcon className="w-4 h-4 text-gray-400 mt-1" />
          <div className="flex-1">
            <label className="text-sm font-medium text-gray-600">Address</label>
            {isEditing ? (
              <div className="grid grid-cols-1 gap-2 mt-1">
                <input
                  type="text"
                  placeholder="Street"
                  value={addr.street || ''}
                  onChange={(e) => handleAddressChange('street', e.target.value)}
                  className="block w-full border border-gray-300 rounded-md shadow-sm p-2"
                />
                <input
                  type="text"
                  placeholder="Village"
                  value={addr.village || ''}
                  onChange={(e) => handleAddressChange('village', e.target.value)}
                  className="block w-full border border-gray-300 rounded-md shadow-sm p-2"
                />
                <div className="grid grid-cols-2 gap-2">
                  <input
                    type="text"
                    placeholder="Post Office"
                    value={addr.postOffice || ''}
                    onChange={(e) => handleAddressChange('postOffice', e.target.value)}
                    className="block w-full border border-gray-300 rounded-md shadow-sm p-2"
                  />
                  <input
                    type="text"
                    placeholder="Police Station"
                    value={addr.policeStation || ''}
                    onChange={(e) => handleAddressChange('policeStation', e.target.value)}
                    className="block w-full border border-gray-300 rounded-md shadow-sm p-2"
                  />
                </div>
                <div className="grid grid-cols-2 gap-2">
                  <input
                    type="text"
                    placeholder="Block"
                    value={addr.block || ''}
                    onChange={(e) => handleAddressChange('block', e.target.value)}
                    className="block w-full border border-gray-300 rounded-md shadow-sm p-2"
                  />
                  <input
                    type="text"
                    placeholder="District"
                    value={addr.district || ''}
                    onChange={(e) => handleAddressChange('district', e.target.value)}
                    className="block w-full border border-gray-300 rounded-md shadow-sm p-2"
                  />
                </div>
                <div className="grid grid-cols-2 gap-2">
                  <input
                    type="text"
                    placeholder="State"
                    value={addr.state || 'Odisha'}
                    onChange={(e) => handleAddressChange('state', e.target.value)}
                    className="block w-full border border-gray-300 rounded-md shadow-sm p-2"
                  />
                  <input
                    type="text"
                    placeholder="Pincode"
                    value={addr.pincode || ''}
                    onChange={(e) => handleAddressChange('pincode', e.target.value)}
                    className="block w-full border border-gray-300 rounded-md shadow-sm p-2"
                  />
                </div>
              </div>
            ) : (
              <p className="text-gray-900">
                {addr.street || ''}{addr.street ? <br /> : null}
                {addr.village || ''}{addr.village ? <br /> : null}
                {addr.postOffice ? `PO: ${addr.postOffice}, ` : ''}{addr.policeStation ? `PS: ${addr.policeStation}` : ''}{(addr.postOffice || addr.policeStation) ? <br /> : null}
                {addr.block ? `${addr.block}, ` : ''}{addr.district || 'N/A'}<br />
                {addr.state || 'Odisha'} {addr.pincode ? `- ${addr.pincode}` : ''}
              </p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactInfoSection;
